import { SiteSizeComparisonChart } from './SiteSizeComparisonChart.tsx';
import { SiteSizeVsSiteValueChartData } from './types.ts';

/** @deprecated - Use SiteSizeVsSiteValueGraph */
export const SiteSizeVsSiteValueChartUnwrapped = ({
  data,
  disableAnimations = false,
  width,
  height,
}: {
  data: SiteSizeVsSiteValueChartData[];
  disableAnimations?: boolean;
  width?: number;
  height?: number;
}) => (
  <SiteSizeComparisonChart
    data={data}
    comparisonKey="siteValue"
    name="Site Value"
    tickFormatter={(val) => `$${(val / 1000).toLocaleString()}k`}
    domain={([dataMin, dataMax]) => {
      const roundedMin = Math.max(0, Math.floor(dataMin / 100_000) * 100_000 - 100_000);
      const roundedMax = Math.ceil(dataMax / 100_000) * 100_000;
      return [roundedMin, roundedMax];
    }}
    tooltipFormatter={(val) => `$${val.toLocaleString()}`}
    disableAnimations={disableAnimations}
    width={width}
    height={height}
  />
);
